import React, { useEffect, useState } from "react";
import "./footer.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import logo from "../../assets/redite-logo.png";
import PopupForm from "../popupform/PopupForm";
import AOS from "aos";
import "aos/dist/aos.css";

function Footer() {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    // message: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    try {
      const response = await fetch("https://sales.redite.in/php/sendemail.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      console.log("Server response:", result);

      if (result.success) {
        setStatus("Mail sent successfully ✔");

        // Reset form
        setFormData({
          name: "",
          email: "",
          phone: "",
          // message: "",
        });
      } else {
        setStatus("Failed to send mail ❌");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setStatus("Error sending mail ❌");
    }

    setLoading(false);
  };

    useEffect(() => {
      AOS.init({
        duration: 800,
        easing: "ease-in-out",
        once: true,
      });
    }, []);
  return (
    <>
    <footer>
      {/* ====== Red Top Banner ====== */}
      <div className="footer-banner">
        <h2 data-aos="fade-right">
          Want to go <span>ONLINE?</span> We’re here to assist!
        </h2>
        <button className="enquiry-btn" data-aos="fade-left"   onClick={() => setOpen(true)} >Enquiry Now</button>
      </div>

      {/* ====== Main Footer Section ====== */}
      <div className="footer-main">
        
        {/* Left Logo + Contact */}
        <div className="footer-col">
          <img src={logo} alt="logo" className="footer-logo" />

          <p className="footer-contact">
            <FaPhoneAlt color="red" /> 9444678233
          </p>

          <p className="footer-contact">
            <FaEnvelope color="red" /> info@redite.in
          </p>

          <p className="footer-contact">
            <FaMapMarkerAlt color="red" /> Okiyam Thoraipakkam, Chennai-600097
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-col footer-col-link">
          <h3>Quick Link</h3>
          <ul>
            <li>Home</li>
            <li>About Us</li>
            <li>Services</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* Get In Touch Form */}
        <div className="footer-col footer-col-link">
          <h3>Get In Touch</h3>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name"
              className="footer-input"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email"
              className="footer-input"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="phone"
              placeholder="phone"
              className="footer-input"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            {/* <textarea
              name="message"
              placeholder="Message"
              className="footer-input footer-textarea"
              value={formData.message}
              onChange={handleChange}
              required
              
            ></textarea> */}

            <button type="submit" className="footer-send" disabled={loading}>
              {loading ? "Sending..." : "Send"}
            </button>

            {status && <p className="footer-status">{status}</p>}
          </form>

        </div>
      </div>
    </footer>

    {open && <PopupForm close={() => setOpen(false)} />}
    </>
  );
}

export default Footer;
